export default {
	// BASE_URL: {
	// 	URL: 'http://localhost:3002/',
	// 	// URL_IO: 'ws://localhost/mtp-socket-dev/',
	// 	URL_IO: 'http://rvscs-develop.com/',

	// 	URL_IMG: 'http://localhost:3002/',
	// 	URL_UPLOAD: 'http://localhost:3002/upload-file/',
	// 	URL_DELETE: 'http://localhost:3002/delete-file/',
	// 	// URL_EXPORT: 'http://localhost/mtp_export/',
	// 	// URL_EXPORT: 'https://mtp-export.rvscs-support.com/',
	// 	URL_EXPORT: 'http://localhost/mtp_export/',
	// 	PATH_IO: '/mtp-socket-dev/socket.io/',
	// 	// URL_EXPORT: 'http://mtp-export.rvscs.com/',
	// },

	BASE_URL: {
		URL: 'https://rvscs-develop.com/mtp-service/',
		URL_IMG: 'https://rvscs-develop.com/mtp-service/',
		URL_UPLOAD: 'https://rvscs-develop.com/mtp-service/upload-file/',
		URL_DELETE: 'https://rvscs-develop.com/mtp-service/delete-file/',
		// URL_EXPORT: 'http://mtp-export.rvscs.com/',
		URL_EXPORT: 'https://mtp-export.rvscs-support.com/',
		URL_IO: 'https://rvscs-develop.com/',
		PATH_IO: '/mtp-socket-dev/socket.io/',
		// URL_EXPORT: 'http://localhost/mtp_export/'
	},

	AUTH_HEADERS: {
		'Accept': 'application/json',
		'Content-Type': 'application/json',
		// "Access-Control-Allow-Origin": "*",
		'x-access-token': localStorage.getItem("x-access-token"),
	},
}
// --max_old_space_size=4096